module.exports = __webpack_public_path__ + "img/ponte.24cbfbe0.png";